import React, { Component } from 'react'

export default class FileInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: ''
    }
  }

  handleChange(e) {
    this.setState({
      value: e.target.value.split(/(\\|\/)/g).pop()
    })

    if (this.props.onChange) this.props.onChange(e)
  }

  render() {
    return (
      <div>
        <input
          type="file"
          name={this.props.name}
          className={this.props.className}
          onChange={this.handleChange.bind(this)}
          disabled={this.props.disabled}
          accept={this.props.accept} />
      </div>
    )
  }
}
